import React from "react";
import Navbar2 from "../../components/Navbar2/Navbar2";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

const DonatePage = () => {
  return (
    <div className="donate-page">
      <Navbar2 />
      <PageTitle pageTitle={"Donate"} pagesub={"Donate"} />
      <div className="wpo-donation-page-area section-padding">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="wpo-donate-header">
                <h2>Make a Donation</h2>
                <p>
                  We are working to enable digital donations on our website
                  soon. In the meantime, please send checks to:
                </p>
                <p>
                  <strong>Friends for Taisha St. Jean Tard</strong>
                  <br />
                  PO Box 13
                  <br />
                  Buffalo, NY 14201
                </p>
              </div>
              {/* 
              <div id="Donations" className="tab-pane">
                <form onSubmit={SubmitHandler}>
                  <!-- Existing form content -->
                </form>
              </div>
              */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <Scrollbar />
    </div>
  );
};

export default DonatePage;
